import React, { Component } from "react";

import styles from "./styles.scss";

import masterImportService from "../../../../services/masterImport";
import masterRuleService from "../../../../services/masterRule";

import CSSModules from "react-css-modules";
import { Button, CircularProgress } from "@material-ui/core";
import { Link } from "react-router-dom";
import { Route, Switch } from "react-router";
import GeneratedChildRules from "../../../../components/GeneratedChildRules/GeneratedChildRules";
import * as router from "react-router-redux";


@CSSModules(styles, { allowMultiple: true })
class ImportStatusRules extends Component {

  constructor(props) {

    super(props);
    this.state = {
      id: props.match.params.id,
      isBusy: true,
      isBusyApplyingChanges: false,
      masterRules: null,
      masterRuleStatus: null,
      hasAppliedChanges: false
    };
  }

  componentDidMount() {
    this.getMasterRules();
  }

  async getMasterRules() {

    try {

      this.setState({ isBusy: true });

      let rules = await masterImportService.getRulesLinkedToSpreadsheetImport(this.state.id);

      if (!rules.length)
        rules = null;

      this.setState({ masterRules: rules, isBusy: false });

    } catch (e) {
      let rules = null;
      this.setState({ masterRules: rules, isBusy: false });
    }


  }

  async applyRuleChanges() {

    try {

      this.setState({ isBusyApplyingChanges: true, hasAppliedChanges: true });
      let appliedMasterRules = await masterImportService.applyChildRuleChangesForSpreadsheetImport(this.state.id);

      this.checkForChangedMasterRules(appliedMasterRules, 0);
    } catch(e) {

      console.error("Exception encountered while trying to apply child rule changes.");
      console.error(e);

    } finally {
      this.setState({ isBusyApplyingChanges: false });
    }
  }

  async checkForChangedMasterRules(appliedMasterRules, count) {
    if(count >= 120) {
      console.error("The master rules did not finish within 10 minutes and will no longer continue to be polled by the page.");
      return;
    }
    let masterRuleStatus = [];
    
    for(let ii = 0, ilen = appliedMasterRules.length; ii < ilen; ii++) {
      let masterRule = await masterRuleService.getMasterRule(appliedMasterRules[ii]);
      masterRuleStatus.push({masterRuleInstanceId: masterRule.masterRuleInstanceId, updateStatusCode: masterRule.updateStatusCode});
    }

    let numberOfApplyingMasterRules = masterRuleStatus.filter(x => x.updateStatusCode != '');
    if(numberOfApplyingMasterRules.length > 0) {
      this.setState({ masterRuleStatus });
      setTimeout(() => {
        this.checkForChangedMasterRules(appliedMasterRules, count++);
      }, 5000);
    } else {
      this.setState({ masterRuleStatus: null });
    }
  }

  render() {

    if (this.state.isBusy === true)
      return <div class={"center-children full-height"}><CircularProgress /></div>;

    if (this.state.masterRules == null || this.state.masterRules.length === 0)
      return (
        <div className={"center-children margin-v-0"}>
          <span>There are no rules linked to this spreadsheet. This can be the case if the import failed or is still processing.</span>
        </div>
      );

    return (

      <div>

        <div style={{marginLeft: "0.5rem"}}>
          <h2>Imported Rules</h2>
          <span>The following master rules were imported from this spreadsheet upload.</span>
        </div>

        {/* List of Master Rules down the Left */}
        <div class="key-config-split-container"
             style={{ marginTop: "2rem" }}>

          <div class="key-column">

            <table class="lightweight-table">
              <thead>
              <tr>
                <th>Master Rule</th>
                <th>Active</th>
                <th>New</th>
                <th>Modified</th>
              </tr>
              </thead>
              <tbody>
              {this.state.masterRules.map((x, i) => {
                return (
                    <tr key={i} class="key-entry">

                      <td>
                        <Link to={`/MasterRules/Import/Status/${this.state.id}/Rules/${x.masterRuleInstanceId}`}>
                        {x.textId}
                        </Link>
                      </td>
                      <td>{x.activeRules}</td>
                      <td>{x.pendingNew}</td>
                      <td>{x.pendingModified}</td>
                    </tr>

                );
              })}
              </tbody>
            </table>

            <div className={"center-children padding-v-0"}>
              <Button onClick={() => this.applyRuleChanges()}
                      variant={"raised"} disabled={this.state.masterRuleStatus!=null&&this.state.masterRuleStatus.length>0}>
                Apply All Changes
              </Button>
              {
                this.state.masterRuleStatus != null && this.state.masterRuleStatus.length > 0 &&
                <div className={"indefinite-load"}>
                  <span></span>
                  <div>{this.state.masterRuleStatus.length} rule{this.state.masterRuleStatus.length>1?'s are ':' is '}currently applying.</div>
                </div>
              }
            </div>


          </div>

          {/* Configuration data for selected tag label */}
          <div class="config-column">

            <Switch>
              <Route path={`/MasterRules/Import/Status/:id/Rules/:ruleId`} component={GeneratedChildRules}
                     key={"import-status-rules" + this.state.ruleId}></Route>
              <Route path={`/MasterRules/Import/Status/:id/Rules`}>
                <div class={"center-children full-height"}>
                  <span>Select a master rule on the left to see child rules.</span>
                </div>
              </Route>
            </Switch>

          </div>

        </div>

      </div>

    );

  }

}

export default ImportStatusRules;



// WEBPACK FOOTER //
// ./src/ui/ImportOverview/ImportStatus/ImportStatusRules/ImportStatusRules.js